import { render } from "./LippudeMäng.vue?vue&type=template&id=012fa2d4&scoped=true"
import script from "./LippudeMäng.vue?vue&type=script&lang=js"
export * from "./LippudeMäng.vue?vue&type=script&lang=js"

import "./LippudeMäng.vue?vue&type=style&index=0&id=012fa2d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012fa2d4"]])

export default __exports__